import { Injectable } from '@angular/core';

interface IUserNotifyMessage {
  icon: "success" | "error" | "warning";
  title: string;
  text: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  messages: IUserNotifyMessage[] = [];

  constructor() { }

  notificationCloseClicked(index: number) {
    this.removeMessageAtIndex(index);
  }

  removeMessageAtIndex(index: number) {
    this.messages.splice(index, 1);
  }

  add(icon: "success" | "error" | "warning", title: string, text?: string) {
    const message = {
      icon,
      title,
      text: text || ""
    };

    this.messages.push(message);

    // Remove the message after 2 seconds
    setTimeout(() => {
      const index = this.messages.indexOf(message);
      if (index !== -1) {
        this.removeMessageAtIndex(index);
      }
    }, 5000);
  }
}
